import {SIGN_TYPE_EVENT, setSignType} from '../../sign-type';

export class Signup {
    constructor($root, fieldIds, param) {
        this.$nativeRoot = $root;
        this.$root = $($root);
        this.id = this.$root.attr('id');
        this.parentControl = param.controlerName;
        this.param = param;
        this.fieldIds = fieldIds;
        this.$notice = this.$root.parents('.modal__content').find('.modal__notice');

        this.$emailErrorWrapper = this.$root.find('[data-email-error]');
        this.$serverErrorWrapper = this.$root.find('[data-server-error]');

        this.submitForm = this.submitForm.bind(this);
        this.switchType = this.switchType.bind(this);
        this.signupFail = this.signupFail.bind(this);
        this.signupDone = this.signupDone.bind(this);

        this.setHandlers();
    }

    setHandlers() {
        this.$root.on('submit', this.submitForm);
        Hop.events.on(SIGN_TYPE_EVENT.CHANGE_TYPE, this.switchType);
    }

    switchType(type) {
        setSignType(type);
    }

    submitForm(e) {
        e.preventDefault();
        this.sendData();
    }

    sendData() {
        fetch('/api/account/signup', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: this.getSignupData(),
        })
            .then(
                (response) => {
                    if (response.ok) {
                        return response;
                    }
                    return Promise.reject(response);
                },
                (err) => {
                    // not an HTTP error, we better have to log that one
                    // see lib-webcommon/webmvc-common/src/main/js/Hop/services/http-client.js
                    console.warn(err);
                    throw err;
                },
            )
            .then(this.signupDone)
            .catch(this.signupFail);
    }

    signupDone() {
        return Hop.connect.control.popupClosed(true);
    }

    async signupFail(response) {
        if (response.status === 400) {
            const errors = await response.json();

            if (errors) {
                this.$emailErrorWrapper.addClass('has-error');
                (errors || []).forEach((err) => {
                    const LI = this.$root.find(`[data-error-${err.attribute}]`);
                    if (LI) {
                        LI.text(err.error);
                    }
                    const inputComponent = this.$root.find(`[data-field-${err.attribute}]`);
                    if (inputComponent) {
                        inputComponent.addClass('invalid');
                    }
                });
            }
        } else {
            // This selector won't be in the DOM with a 403 error
            if (this.$serverErrorWrapper) {
                this.$emailErrorWrapper.removeClass('has-error');
                this.$serverErrorWrapper.addClass('has-error');
                this.$serverErrorWrapper.find('li').text(this.param.signupUnexpectedErrorMessage);
            }

            // will be properly caught and logged
            const e = new Error(response.responseText);
            e.name = 'UNEXPECTED_SERVER_RESPONSE';
            throw e;
        }
    }

    getSignupData() {
        const legalsCb = this.$root.find('input[name=' + this.fieldIds.legals + ']');
        const optOutFromNewsCb = this.$root.find('input[name=' + this.fieldIds.optOutFromNews + ']');
        const invitationType = this.$root.find('input[name="invitationType"]');

        return JSON.stringify({
            email: this.$root.find('input[name=' + this.fieldIds.email + ']').val(),
            password: this.$root.find('input[name=' + this.fieldIds.password + ']').val(),
            firstName: this.$root.find('input[name=' + this.fieldIds.firstName + ']').val(),
            lastName: this.$root.find('input[name=' + this.fieldIds.lastName + ']').val(),
            legals: legalsCb.length ? legalsCb.prop('checked') : null,
            optOutFromNews: optOutFromNewsCb.length ? optOutFromNewsCb.prop('checked') : null,
            invitationType: invitationType.length ? invitationType.val() : null,
        });
    }

    destroy() {
        const idButton = this.$root.find('button').attr('id');
        Hop.destroyObj(idButton);

        this.$root.off('submit', this.submitForm);
        Hop.events.off(SIGN_TYPE_EVENT.CHANGE_TYPE, this.switchType);
    }
}
